









import Vue from 'vue';
import { Icon } from '@/components/ds';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: !this.$props.isVisible,
    };
  },
  watch: {
    isVisible(value) {
      this.collapsed = !value;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
